import { useCallback, useEffect, useState } from 'react';
import {
  useDeleteMemberNoteMutation,
  useGetMemberNotesQuery
} from '@bo-services/members/memberNotesApi';
import { GET_MEMBER_NOTES_PER_PAGE_COUNT } from '@bo-constants/member/memberNotes';
import { useParams } from 'react-router-dom';

export interface MemberNotesProps {
  isResetCurrentPage: boolean;
}

export const useMemberNotes = ({ isResetCurrentPage }: MemberNotesProps) => {
  const { memberId } = useParams<{ memberId?: string }>();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { data, isLoading, isFetching, isError } = useGetMemberNotesQuery(
    {
      memberId,
      page: currentPage,
      perPage: GET_MEMBER_NOTES_PER_PAGE_COUNT
    },
    {
      skip: !memberId
    }
  );

  const [deleteMemberNote] = useDeleteMemberNoteMutation();

  const isNotesLoading = isLoading || isFetching;

  const { data: notes = [], totalPages = 0 } = data || {};

  const handleCurrentPageChange = useCallback(() => {
    setCurrentPage((prevPage) => prevPage + 1);
  }, []);

  const handleDeleteMemberNote = useCallback(
    async (id: string) => {
      if (!memberId) {
        return;
      }

      await deleteMemberNote({ memberId, id });
    },
    [deleteMemberNote, memberId]
  );

  useEffect(() => {
    if (isResetCurrentPage) {
      setCurrentPage(1);
    }
  }, [isResetCurrentPage]);

  return {
    currentPage,
    isError,
    isLoading: isNotesLoading,
    notes,
    onCurrentPageChange: handleCurrentPageChange,
    onDeleteMemberNote: handleDeleteMemberNote,
    totalPages
  };
};
